const HCP_ACCEPTED = 'HCP_ACCEPTED';
const HCP_SHOW_DELAY = 1000;

export { HCP_ACCEPTED, HCP_SHOW_DELAY };
